import React from 'react';
import PropTypes from 'prop-types';

const dropdownPropTypes = {
  buttonText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.any, // Only req for prop generated by createFragment
      // PropTypes.element,
      // PropTypes.arrayOf(PropTypes.element),
    ])),
  ]).isRequired,
  id: PropTypes.string.isRequired,
  menuId: PropTypes.string,
  buttonId: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ])),
  ]).isRequired,
  buttonClass: PropTypes.string,
  menuPositionClass: PropTypes.string,
};
const defaultProps = {
  disabled: false,
  onClick: null,
  label: null,
  buttonId: null,
  menuId: null,
  buttonClass: 'btn btn-link',
  menuPositionClass: 'dropdown-menu-right'
};

export default class DropDown extends React.PureComponent {
  static propTypes = dropdownPropTypes;

  static defaultProps = defaultProps;

  constructor(props) {
    super(props);

    this.setButtonRef = element => {
      this.buttonRef = element
    };
  }

  componentDidMount() {
    if (this.buttonRef) {
      $(this.buttonRef).dropdown();
    }
  }

  render() {
    const { buttonText, id, menuId: menuIdProp, buttonId: buttonIdProp,
      disabled, onClick, children, label,
      menuPositionClass, buttonClass } = this.props;
    const buttonId = buttonIdProp || `${id}-button`;
    const menuId = menuIdProp || `${id}-menu`;

    return (
      <div className='dropdown'>
        <button
          ref={this.setButtonRef}
          id={buttonId}
          data-test-id={buttonId}
          disabled={disabled}
          type='button'
          className={`${buttonClass} dropdown-toggle`}
          data-toggle='dropdown'
          aria-controls={menuId}
          aria-label={label}
          aria-haspopup='listbox'
          onClick={onClick}
        >
          {buttonText}
        </button>
        <div
          id={menuId}
          className={`dropdown-menu ${menuPositionClass}`}
        >
          {children}
        </div>
      </div>
    );
  }
}
